import { forwardRef } from 'react';
import cn from 'bem-cn';

import { VideoProps } from './Video.types';

const b = cn('video');

export const Video = forwardRef<HTMLVideoElement, VideoProps>((props, ref) => {
    const { src, className, type = 'video/mp4', ...restProps } = props;

    return (
        <video
            ref={ref}
            className={b.mix(className)}
            // @ts-expect-error аттрибут убирает кнопки на видео в яндекс браузере
            pip="false"
            {...restProps}
        >
            <source src={src} type={type} />
        </video>
    );
});

Video.displayName = 'Video';
